import { render, staticRenderFns } from "./CalendarOutlineIcon.vue?vue&type=template&id=7540acd8"
import script from "./CalendarOutlineIcon.vue?vue&type=script&lang=js"
export * from "./CalendarOutlineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports